const language: "uz" | "en" | "ru" =
  (localStorage.getItem("language") as "uz" | "en" | "ru") || "uz";

export default language;
